import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circled-play",
  "use": "icon-circled-play-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" id=\"icon-circled-play\">\n  <path d=\"M32 8C18.7656 8 8 18.7656 8 32C8 45.2344 18.7656 56 32 56C45.2344 56 56 45.2344 56 32C56 18.7656 45.2344 8 32 8ZM32 12C43.0703 12 52 20.9297 52 32C52 43.0703 43.0703 52 32 52C20.9297 52 12 43.0703 12 32C12 20.9297 20.9297 12 32 12ZM24 18.25V45.75L27 44L45 33.75L48 32L45 30.25L27 20L24 18.25ZM28 25.125L39.9375 32L28 38.875V25.125Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol